import isNull from 'lodash/isNull';

export default {
  methods: {
    hasLocationData(timePair) {
      if (isNull(timePair)) return false;
      return ((timePair.clockIn.accuracy > 0) || (timePair.clockOut && timePair.clockOut.accuracy > 0));
    },
  },
};
